import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
} from '@chakra-ui/react';

import CanalForm from './ConfigurarForm';

type ConfigurarModalProps = {
  isOpen: boolean;
  onClose: () => void;
  data?: { nome?: string } | null;
};

export default function ConfigurarModal({
  isOpen,
  onClose,
  data,
}: ConfigurarModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />

      <ModalContent borderRadius="2xl">
        <ModalHeader>Configurar {data?.nome}</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <CanalForm data={data} />
        </ModalBody>

        <ModalFooter gap="3">
          <Button onClick={onClose} variant="ghost">
            Cancelar
          </Button>

          <Button colorScheme="blue">Salvar Configurações</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
